export default "__VITE_ASSET__Cgz5i5OQ__"